import * as React from "react";
import { twMerge } from "tailwind-merge";
import Button from "./Button";

export type TabItem = {
  label: string;
  value: string;
};

export type TabsProps = {
  value?: string;
  items?: TabItem[];
  onChange?: (value: string) => void;
  className?: string;
};

export default function Tabs({
  value,
  items = [],
  onChange = () => {},
  className,
}: TabsProps) {
  const activeIndex = Math.max(
    0,
    items.findIndex((i) => i.value === value),
  );

  const onKeyDown = React.useCallback(
    (e: React.KeyboardEvent<HTMLDivElement>) => {
      if (!items.length) return;
      if (e.key !== "ArrowLeft" && e.key !== "ArrowRight") return;
      e.preventDefault();
      const dir = e.key === "ArrowRight" ? 1 : -1;
      const next = (activeIndex + dir + items.length) % items.length;
      onChange(items[next]!.value);
    },
    [activeIndex, items, onChange],
  );

  return (
    <div
      role="tablist"
      aria-orientation="horizontal"
      onKeyDown={onKeyDown}
      className={twMerge(
        "inline-flex items-center rounded-full bg-background p-[4px]",
        className,
      )}
    >
      {items.map((item) => {
        const isActive = item.value === value;
        return (
          <Button
            children={item.label}
            onClick={() => onChange(item.value)}
            className={twMerge(
              "shadow-soft-none box-shadow-none h-[32px]",
              !isActive && "bg-transparent",
            )}
          />
        );
      })}
    </div>
  );
}
